import PromotionsApi from '../../api/PromotionsApi';

const state = {
  promotion: null,
};

const actions = {
  async fetchPromotion({ commit }, promoCode) {
    const promotion = await PromotionsApi.getPromotion(promoCode);
    if (promotion) {
      commit('setPromotion', promotion.name);
    }
  },
};

const mutations = {
  setPromotion(state, promotion) {
    state.promotion = promotion; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
